var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
function SvgPowergonP(passedProps, svgRef) {
    var props = __assign({}, passedProps);
    return (React.createElement("svg", __assign({ width: "1.5em", height: "1.5em", viewBox: "0 0 31 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: svgRef }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M23.924 6.526l.01.007a.35.35 0 01.141.284v6.449c0 .111-.053.22-.144.284l-.011.007-9.148 6.618v2.756c0 .05-.018.1-.046.144a.24.24 0 01-.339.057l-8.763-6.341-.01-.008a.348.348 0 01-.145-.283v-6.45c0-.111.053-.219.145-.283l.01-.008 9.152-6.618V.385c0-.05.017-.1.046-.143a.24.24 0 01.339-.058l8.763 6.342zm-8.227 6.945c1.29-.234 2.222-.802 2.766-1.689.463-.754.533-1.57.526-1.983 0-.417-.067-1.204-.53-1.79-.547-.69-1.476-.923-2.765-.69l-3.161.568a.087.087 0 00-.057.036.085.085 0 00-.014.065l.127.586v7.89l-.127.629c-.003.017 0 .039.014.057a.064.064 0 00.057.018l2.172-.392a.088.088 0 00.074-.086v-3.054l.918-.165zm-.915-3.84l.93-.17c1.013-.18 1.013.514 1.013.74 0 .622-.332.985-1.014 1.107l-.929.17V9.63z", fill: "#242B42" })));
}
var ForwardRef = React.forwardRef(SvgPowergonP);
export default ForwardRef;
